import React from 'react';
import {
  StyleWrapperEdit,
  StyleWrapperView,
} from '@eeacms/volto-block-style/StyleWrapper';

// For blocks, store the style data in data.styles, then
// adapt the data.styles.[align,size,...] info to default data.align, data.size, etc.

const BlockStyleWrapperEdit = (props) => {
  const { block, data = {}, onChangeBlock } = props;
  const [isVisible, setIsVisible] = React.useState(false);

  return (
    <>
      <StyleWrapperEdit
        {...props}
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        data={{
          ...data?.styles,
          ...(data.align ? { align: data.align } : {}),
          ...(data.size ? { size: data.size } : {}),
        }}
        blockData={data}
        choices={[]}
        onChangeValue={(id, value) =>
          onChangeBlock(block, {
            ...data,
            ...(id === 'align' ? { align: value } : {}),
            ...(id === 'size' ? { size: value } : {}),
            ...(id === 'customId' ? { id: value } : {}),
            styles: {
              ...data?.styles,
              [id]: value,
            },
          })
        }
      ></StyleWrapperEdit>
      <StyleWrapperView
        mode="edit"
        {...props}
        styleData={
          data['@type'] === 'teaser'
            ? { ...data.styles, align: 'center' }
            : data.styles || {}
        }
      />
    </>
  );
};

export default BlockStyleWrapperEdit;
